import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--paper)]" data-testid="auth-loading">
      <Loader2 className="h-6 w-6 animate-spin text-[var(--brand)]" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
